import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './select.html' with { type: 'html' };

export default {
	name: 'CSelect',
	components: {
		cSvg
	},
	inheritAttrs: false,
	props: {
		customClass: {
			type: String,
			default: ''
		},
		form: {
			type: Object,
			default: () => {}
		},
		hasIcon: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		isShortened: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			required: true
		},
		order: {
			type: Object,
			default: () => null
		},
		selected: {
			type: [String, Number]
		}
	},
	computed: {
		selectedVariant() {
			let selectedVariant = this.selected;
			const foundSelectedOption = this.options.find((option) => option.selected);
			if (!selectedVariant && foundSelectedOption) {
				selectedVariant = foundSelectedOption.value;
			}
			return selectedVariant;
		},
		iconName() {
			const selectedCountry = Object.values(this.options).filter((option) => option.value === this.selectedVariant);
			return selectedCountry.length && selectedCountry[0].hasIcon ? `#flag-${this.selectedVariant}` : '#flag-other';
		},
		isCountryDisabledByCustomID() {
			// CustomID that disables a country selector for every payment method
			return this.isCustomId['COUNTRYOFF'];
		},
		closedValue() {
			if (this.isShortened) {
				return this.selectedVariant;
			} else {
				const filteredVariant = Object.values(this.options).find((option) => option.value === this.selectedVariant);
				return filteredVariant ? filteredVariant.label : '';
			}
		}
	},
	methods: {
		emit(event) {
			this.$emit('input', {
				value: event.target.value,
				target: event.target
			});
		}
	},
	template
};
